import { Component,Input,Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ModalController, NavController } from 'ionic-angular';
import { Assessment } from '../../models/assessment';
import { ClientPage } from '../../pages/client/client';
import { Items } from '../../providers/providers';
import { AddBatteryPage } from '../../pages/add-battery/add-battery';
import { Batteries } from '../../models/batteries';

/**
 * Generated class for the AssessmentDetailsComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'assessment-details',
  templateUrl: 'assessment-details.html'
})
export class AssessmentDetailsComponent {

  @Input() assessment: Assessment;
  @Input() text: string;
  @Input() battery: Batteries;
  @Output() assessmentChange: EventEmitter<Assessment> = new EventEmitter<Assessment>();
  @Output() batteryChange: EventEmitter<Batteries> = new EventEmitter<Batteries>();
  clientBatteries: Assessment[];

  constructor(public modalCtrl: ModalController, private items: Items, public navCtrl: NavController) {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName === 'battery') {
        let battery = changes['battery'].currentValue;
        if(typeof battery === 'undefined'){
          //do nothing
        }else{
          this.clientBatteries = [];
          if(this.battery.assessments != null){
            for(let i = 0; i < this.battery.assessments.length; i++ ){
              var assessmentId = this.battery.assessments[i];
              var assessment = this.getAssessmentForId(assessmentId);
              this.clientBatteries.push(assessment);
            }
          }
          
          
        }
        
      } 
      
    }
    
  }

  getAssessmentForId(assessmentId){
    var data = localStorage.getItem("assessments");
    var assessments = JSON.parse(data);
    return assessments.find(x => x.id == assessmentId);
  }

  administer() {
    let modal = this.modalCtrl.create('ClientPage',{administer: 'administer',assessment:this.assessment});
    modal.present();
  }

  emailAssessment(){
    let modal = this.modalCtrl.create('ClientPage',{administer: 'email',assessment:this.assessment});
    modal.present();
  }

  scheduleAssessment(){
    let modal = this.modalCtrl.create('ClientPage',{administer: 'schedule',assessment:this.assessment});
    modal.present();
  }
  
  downloadAssessment(id){
    var url = "https://growingminds-api.novopsych.com/assessments/form/"
    window.open(url + id,"_blank","location=false");
  }

  singleAssessmentSelected(val){
    let assessment: Assessment;
    var data = localStorage.getItem("assessments");
    var assessments = JSON.parse(data);
    assessment = assessments.find(x => x.id == val);
    this.assessmentChange.emit(assessment);

  }

  addBattery(){
    let modal = this.modalCtrl.create(AddBatteryPage,null,{cssClass:"add-battery-modal"});
    modal.onDidDismiss(item => {
      if (item) {
        let seq =  this.items.addBattery({name:item.form.name, description: item.form.description, assessments: item.assessments}).share();
        seq
          .map(res => res.json().data.battery)
          .subscribe(res => {
            if(res){
              this.battery = res;
              this.batteryChange.emit(this.battery);
            }
          }, err => {
            console.error('ERROR', err);
          });
      }
    })
    modal.present();
  }

  administerBattery() {
    let modal = this.modalCtrl.create('ClientPage',{administer: 'administerBattery',assessment:this.battery.assessments});
    modal.present();
  }

  emailBattery(){
    let modal = this.modalCtrl.create('ClientPage',{administer: 'emailBattery',assessment:this.battery.assessments});
    modal.present();
  }

  scheduleBattery(){
    let modal = this.modalCtrl.create('ClientPage',{administer: 'scheduleBattery',assessment:this.battery.assessments});
    modal.present();
  }

  editBattery(battery) {
    let addModal = this.modalCtrl.create(AddBatteryPage,{battery: battery},{cssClass:"add-battery-modal"});
    addModal.onDidDismiss(item => {
      if (item) {
        if (item.dismiss === 'done') {
          let seq = this.items.editBattery({name:item.form.name, description: item.form.description, assessments: item.assessments}, battery.id).share();
          seq
            .map(res => res.json().data.battery)
            .subscribe(res => {
              this.battery = res;
              this.batteryChange.emit(this.battery);
            }, err => {
              console.error('ERROR', err);
            });
        } else {
          if (item.dismiss === 'delete') {
            battery.active = "0";
            let seq = this.items.deleteBattery(battery, battery.id).share();
            seq
              .map(res => res.json().data.battery)
              .subscribe(res => {
                // this.battery = res;
                this.batteryChange.emit(battery);
              }, err => {
                console.error('ERROR', err);
              });
          }
        }
      }
    })
    addModal.present();
  }


}



// WEBPACK FOOTER //
// ./src/components/assessment-details/assessment-details.ts